import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import textAreaValidator from '../../foundation/js/inputValidators/textAreaValidator'

const options = formFieldCommonOptions('FormInputTextarea', {
    validatorFunction(input) {
        return textAreaValidator(input)
    }
})

export default options
